module.exports = __webpack_public_path__ + "img/mobile-main-image.b4169d77.png";